import { apiClient } from './api';

export const authService = {
  async register(userData: {
    username: string;
    email: string;
    password: string;
    dietaryPreferences?: string[];
    excludedIngredients?: string[];
  }) {
    try {
      console.log('📝 Attempting registration for:', userData.username);

      const response = await apiClient.post('/auth/register', userData);

      console.log('✅ Registration successful for:', userData.username);
      return response; // Devuelve { token, type, id, username, email }
    } catch (error) {
      console.error('❌ Registration failed:', error);
      throw error;
    }
  },

  async login(credentials: { username: string; password: string; }) {
    try {
      console.log('🔐 Attempting login for:', credentials.username);

      const response = await apiClient.post('/auth/login', credentials);

      console.log('✅ Login successful for:', credentials.username);
      return response; // Devuelve { token, type, id, username, email }
    } catch (error) {
      console.error('❌ Login failed:', error);
      throw error;
    }
  },

  // Nuevos métodos para verificar disponibilidad
  async checkUsernameAvailability(username: string): Promise<boolean> {
    try {
      console.log('🔍 Checking username availability:', username);

      const response = await apiClient.get(`/auth/check-username/${username}`);

      console.log('✅ Username availability result:', response);
      return response; // Devuelve true si está disponible
    } catch (error) {
      console.error('❌ Username check failed:', error);
      throw error;
    }
  },

  async checkEmailAvailability(email: string): Promise<boolean> {
    try {
      console.log('🔍 Checking email availability:', email);

      const response = await apiClient.get(`/auth/check-email/${email}`);

      console.log('✅ Email availability result:', response);
      return response; // Devuelve true si está disponible
    } catch (error) {
      console.error('❌ Email check failed:', error);
      throw error;
    }
  },

  // Método opcional para logout (si tu backend lo soporta)
  async logout(token?: string) {
    try {
      if (token) {
        await apiClient.post('/auth/logout', {}, token);
        console.log('✅ Logout successful');
      }
    } catch (error) {
      console.error('❌ Logout API call failed:', error);
      // No lanzamos error para no afectar la experiencia de usuario
    }
  },

  // Método opcional para verificar token
  async validateToken(token: string) {
    try {
      const response = await apiClient.get('/auth/validate', token);
      return response.valid || true; // Adaptar según la respuesta de tu backend
    } catch (error) {
      console.error('❌ Token validation failed:', error);
      return false;
    }
  },

  // Método para recuperar contraseña (si está implementado en el backend)
  async forgotPassword(email: string) {
    try {
      const response = await apiClient.post('/auth/forgot-password', { email });
      console.log('✅ Password reset email sent');
      return response;
    } catch (error) {
      console.error('❌ Forgot password failed:', error);
      throw error;
    }
  },

  // Método para resetear contraseña (si está implementado en el backend)
  async resetPassword(token: string, newPassword: string) {
    try {
      const response = await apiClient.post('/auth/reset-password', {
        token,
        newPassword
      });
      console.log('✅ Password reset successful');
      return response;
    } catch (error) {
      console.error('❌ Password reset failed:', error);
      throw error;
    }
  }
};
// const API_BASE_URL = 'http://localhost:8081/api';

// export const authService = {
//   async register(userData: { 
//     username: string; 
//     email: string; 
//     password: string;
//     dietaryPreferences?: string[];
//     excludedIngredients?: string[];
//   }) {
//     const response = await fetch(`${API_BASE_URL}/auth/register`, { // Cambiado a /auth/register
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(userData),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Registration failed');
//     }

//     return response.json(); // Devuelve { token, type, id, username, email }
//   },

//   async login(credentials: { username: string; password: string; }) { // Cambiado a username en lugar de email
//     const response = await fetch(`${API_BASE_URL}/auth/login`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(credentials),
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Login failed');
//     }

//     return response.json(); // Devuelve { token, type, id, username, email }
//   },

//   // Nuevos métodos para verificar disponibilidad
//   async checkUsernameAvailability(username: string): Promise<boolean> {
//     const response = await fetch(`${API_BASE_URL}/auth/check-username/${username}`);
//     if (!response.ok) {
//       throw new Error('Failed to check username availability');
//     }
//     return response.json(); // Devuelve true si está disponible
//   },

//   async checkEmailAvailability(email: string): Promise<boolean> {
//     const response = await fetch(`${API_BASE_URL}/auth/check-email/${email}`);
//     if (!response.ok) {
//       throw new Error('Failed to check email availability');
//     }
//     return response.json(); // Devuelve true si está disponible
//   },
// };